<a
  data-test="6sXz6OG9"
  class="dropdown__menu-link assignments__menu-item"
  *ngIf="timeslots$ | async | notNull as timeslots"
>
  Assignments ({{ timeslots.length }} unconfirmed)

  <div data-test="rj0dLEwM" class="assignments-container">
    <ul
      data-test="ZRx55zLC"
      *ngIf="timeslots.length === 0"
      class="timeslot-list dropdown__wrap"
    >
      <li data-test="8C-HSvSR">
        <span data-test="b4iNBswG">Nothing found.</span>
      </li>
    </ul>

    <ul
      data-test="yzdoJZ_H"
      class="timeslot-list dropdown__wrap"
      *ngIf="timeslots.length > 0"
    >
      <li
        class="item"
        data-test="80_M3Vox"
        *ngFor="let slot of timeslots"
        (click)="showConfirmDialog(slot)"
      >
        <div data-test="9JsBAaXB" class="task-title">
          {{ slot.assignment?.projectTask?.name }}
        </div>
        <div data-test="svzf7qWT" class="project-id">
          {{ slot.assignment?.projectTask?.project?.projectId }}
        </div>
        <div data-test="_AOFSoxG" class="project-name">
          {{ slot.assignment?.projectTask?.project?.name }}
        </div>
      </li>
    </ul>
  </div>
</a>
